<div>
	<div class="remote-application-container-root">
		@if (descriptor()) {
			<sl-embedded-remote-application [descriptor]="descriptor()!" />
		}
	</div>
</div>
